import { useSoyuzExperiment } from '@spotahome/soyuz/client';

import useAutocompleteServiceMapbox from './useAutocompleteService.mapbox';
import useAutocompleteServiceGoogle from './useAutocompleteService.google';
import useAutocompleteServiceWoosmap from './useAutocompleteService.woosmap';
import useAutocompleteServiceMaptiler from './useAutocompleteService.maptiler';

// Dispatcher for the MapProviderWoosmapMapTiler experiment. The bucket is
// session-scoped, so the chosen branch is stable across renders of any given
// component instance — the rules-of-hooks rule is satisfied in practice, even
// though the lint can't prove it statically.
const useAutocompleteService = props => {
  const mapProviderVariant = useSoyuzExperiment('MapProviderWoosmapMapTiler').get(
    'behaviour'
  );

  if (mapProviderVariant === 'mapbox') {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return useAutocompleteServiceMapbox(props);
  }

  if (mapProviderVariant === 'woosmap') {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return useAutocompleteServiceWoosmap(props);
  }

  if (mapProviderVariant === 'maptiler') {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return useAutocompleteServiceMaptiler(props);
  }

  // eslint-disable-next-line react-hooks/rules-of-hooks
  return useAutocompleteServiceGoogle(props);
};

export default useAutocompleteService;
